import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import { BsArrowClockwise } from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { getReportLoanHomeAccAPI } from '../../../services/report'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { ExportExcelLip } from '../../../helper/exportExcelLip'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import excelImg from '../../../images/xlsFile.svg'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import styled from 'styled-components'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'

export default function ReportLoanHomePage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRow, setTotalRow] = useState(0)
  const [dataTable, setDataTable] = useState([])
  const totalLimits = 20
  const [bodyFilter, setBodyFilter] = useState()
  const [page, setPage] = useState(1)
  const [statusActive, setStatusActive] = useState({ label: 'All', value: '' })
  useEffect(() => {
    const body = {
      page: 1,
      orgId: roleId
    }
    setPage(1)
    if (roleId) fnGetData(body)
  }, [roleId])

  const fnGetData = async (body, isExcel = false) => {
    setIsLoading(true)
    if (!isExcel) {
      setBodyFilter(body)
    }
    const resp = await getReportLoanHomeAccAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      if (isExcel) {
        const dataExcel = resp.result.map((d, i) => {
          return {
            num: i + 1,
            code: d.code,
            name: `${d.titleTh} ${d.nameTh} ${d.surnameTh}`,
            bank: d.bank,
            loanAcc: d.loanAcc,
            activeStatusName: d.activeStatusName
          }
        })
        const header = ['#', 'Code', 'Name', 'Bank', 'Acc', 'Status']

        ExportExcelLip({ header, dataExcel, fileName: 'excel' })
      } else {
        setDataTable(resp.result)
        setTotalRow(resp.totalRows)
      }
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnExportExcel = () => {
    const body = {
      page: 1,
      size: totalRow,
      ...bodyFilter
      // orgId: roleId
    }
    fnGetData(body, true)
  }

  const { control, setValue, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      page: 1,
      orgId: roleId,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      page: 1,
      orgId: roleId,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }
  return (
    <div>
      <NavTitle>
        <TextNavTitle>เลขบัญชีผู้กู้</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3">
            <Row>
              <Col md={4} className="my-auto small">
              <label
                  className="my-auto fw-bold me-3"
                  style={{
                    fontSize: '14px'
                  }}
                >
                  Total: {totalRow?.toLocaleString()}
                </label>
              </Col>

              <Col md={8} className="">
                <BoxFilter className="justify-content-end">
                  <div className="btn-status">
                    <AutocompleteCustom
                      options={[
                        { label: 'Active', value: 1 },
                        { label: 'Inactive', value: 2 },
                        { label: 'All', value: '' }
                      ]}
                      value={statusActive}
                      onChange={(e) => {
                        const d = {
                          ...bodyFilter,
                          page: 1,
                          active: e.value
                        }
                        setPage(1)
                        setStatusActive(e)
                        fnGetData(d)
                      }}
                    />
                  </div>
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>

                  <Button
                    className="btn-reflesh"
                    variant="light"
                    onClick={() => {
                      const body = {
                        page: 1,
                        orgId: roleId
                      }
                      setStatusActive({ label: 'All', value: '' })
                      setValue('search', '')
                      setPage(1)
                      fnGetData(body)
                    }}
                  >
                    <BsArrowClockwise />
                  </Button>
                  <Button className="btn-excel" onClick={() => fnExportExcel()}>
                    <Image src={excelImg} style={{ width: '15px' }} />
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>

          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Bank</th>
                <th className="fw-normal">Acc</th>
                <th className="text-center fw-normal">Status</th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {isLoading ? (
                <>
                  <TableSkeletonBody colSpan={6} rowSpan={10} />
                </>
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td className="">
                      <div>{d.code}</div>
                      <label className="small opacity-50">({d.personId})</label>
                    </td>
                    <td className="">
                      <div>
                        {d.titleTh}
                        {d.nameTh} {d.surnameTh}
                      </div>
                      <div>
                        {d.titleEn} {d.nameEn} {d.surnameEn}
                      </div>
                    </td>

                    <td className="">{d.bank}</td>
                    <td className="">{d.loanAcc}</td>
                    <td className="text-center">
                      <span
                        className={`${
                          d.active === 2 ? 'opacity-50' : 'text-success'
                        }`}
                      >
                        {d.activeStatusName}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="font-small-2 align-middle">
                  <td colSpan={7} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRow}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }
  .btn-reflesh {
    flex: 0 0 30px;
  }
  .btn-excel {
    flex: 0 0 30px;
  }
  .btn-status {
    flex: 0 0 150px;
  }
`
